import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { useMessagesStore } from '@/stores/messages'

export const useEmailExportingStore = defineStore('emailExporting', {
  state: () => ({
    storyId: null,
    to: null,
    subject: null,
    notes: null,
  }),

  actions: {
    async send() {
      const { to, subject, notes } = this

      return httpClient.post('/api/internal/emails', {
        email_export: {
          story_id: this.storyId,
          to,
          subject,
          notes,
        }
      }).then(({ data }) => {
        useMessagesStore().addNotice(data.message)
        this.$reset()

        return data
      }).catch(err => {
        useMessagesStore().addError(err)
      })
    }
  }
})
